import { alpha, Button, useTheme } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { negativeTrendColorState, positiveTrendColorState } from 'states';

interface BuySellBtnProps {
  onClick: () => void;
  isBuy: boolean;
}

const BuySellBtn = ({ onClick, isBuy }: BuySellBtnProps) => {
  const theme = useTheme();
  const serverPosColor = useRecoilValue(positiveTrendColorState);
  const serverNegColor = useRecoilValue(negativeTrendColorState);
  const color = isBuy ? serverPosColor : serverNegColor;
  const flipColor = isBuy ? serverNegColor : serverPosColor;

  return (
    <Button
      size="small"
      variant="contained"
      disableElevation
      onClick={onClick}
      sx={{
        minWidth: 52,
        width: 52,
        height: 30,
        p: 0,
        position: 'relative',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.02em',
        color: theme.palette.getContrastText(color),
        backgroundColor: color,
        '&:after': {
          content: '"⇄"',
          position: 'absolute',
          top: '-7px',
          right: '-7px',
          color: theme.palette.getContrastText(flipColor),
          backgroundColor: flipColor,
          borderRadius: '50%',
          width: '16px',
          height: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '10px',
          lineHeight: 1,
          boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.3)}`,
        },
        '&:hover': {
          backgroundColor: alpha(color, 0.85),
        },
      }}
    >
      {isBuy ? 'BTO' : 'STO'}
    </Button>
  );
};

export default BuySellBtn;
